module.exports = __webpack_public_path__ + "img/엘스포츠3.3d440f87.png";